import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    headerContainer: {
        paddingBottom: '24%',
        backgroundColor: theme.palette.grey[700],
        width: '100%',
        position: 'relative',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        maxHeight: '420px',
        minHeight: '180px'
    },
    headerImage: {},

    gridContainer: {
        position: 'absolute',
        top: '0px',
        bottom: '0px',
        height: '100%',
        width: '100%',
        padding: '0px',
        margin: '0px',
        maxWidth: '100%'
    },
    image: {
        maxHeight: '200px'
    },
    text: {
        color: '#ffffff'
    }
}));

export default function HeaderImage(props) {

    const { img, backgroundImage, text, imgAlt, textVariant } = props;

    const classes = useStyles();

    const headerContainerImage = {
        backgroundImage: 'url(' + backgroundImage + ')'
    }

    return (
        <div className={classes.headerContainer} style={headerContainerImage}>
            <div className={classes.headerOpacity}></div>
            <Grid container justify="center" alignItems="center" classes={{ container: classes.gridContainer }}>
                <Grid item>
                    { img ? (
                        <img className={classes.image} src={img} alt={imgAlt}/>
                    ) : (
                        <Typography variant={ textVariant || 'h2'} className={classes.text}>
                            {text}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </div>
    );
}
